import { INavItem } from "../interfaces/common.interface";

export const NAV_MENU_LIST: INavItem[] = [
    // {
    //     levelOneId: "",
    //     url: "flash",
    //     title: "Flash",
    //     icon: "dashboard",
    //     levelTwo: [
    //         {
    //             levelTwoId: "",
    //             url: "claims",
    //             title: "Claims",
    //             icon: "receipt",
    //         },
    //         {
    //             levelTwoId: "",
    //             url: "policies",
    //             title: "Policies",
    //             icon: "verified",
    //         },
    //     ],
    // },
    {
        levelOneId: "",
        url: "tts",
        title: "TTS",
        icon: "dashboard",
        levelTwo: [
            {
                levelTwoId: "",
                url: "claims",
                title: "Claims",
                icon: "receipt",
            },
            {
                levelTwoId: "",
                url: "policies",
                title: "Policies",
                icon: "verified",
            },
        ],
    },
    {
        levelOneId: "",
        url: "shopee-food",
        title: "Shopee Food",
        icon: "two_wheeler",
        levelTwo: [
            {
                levelTwoId: "",
                url: "declarations",
                title: "Declarations",
                icon: "verified",
            },
            {
                levelTwoId: "",
                url: "claims",
                title: "Claims",
                icon: "receipt",
            },
        ],
    },
];
